const _excluded = ["selected", "onClick"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Typography, Button } from 'seagull';
import { Intent } from "../../../infra/access-control";
import styles from "./BottomArea.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function BottomArea(_ref) {
  let {
      selected,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", {
    className: styles.bottomArea,
    children: selected ? /*#__PURE__*/_jsx(Typography, {
      className: styles.selectedIndicator,
      "data-testid": "".concat(props['data-testid'], "-selected"),
      children: "Selected"
    }) : /*#__PURE__*/_jsx(Button, {
      intent: Intent.SelectPackage,
      "data-testid": "".concat(props['data-testid'], "-select-btn"),
      skin: "primaryOutlineOpaque",
      onClick: onClick,
      children: "Select"
    })
  });
}